import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getApiKeys = () => {
    return axiosPrivate.get(`/dashboard/api/v1/auth_keys`)
}